import { useCallback } from 'react';
import { LogoutReason } from '../constants/auth';
import { authActions, selectAuthLoading, selectAuthUser, selectCanWrite, selectLogoutReason } from './authSlice';
import { useAppDispatch, useAppSelector } from './hooks';

/** Returns the auth values components need without depending on a React context wrapper. */
export const useAuthState = () => {
  const user = useAppSelector(selectAuthUser);
  const loading = useAppSelector(selectAuthLoading);
  const logoutReason = useAppSelector(selectLogoutReason);
  const canWrite = useAppSelector(selectCanWrite);

  return { user, loading, logoutReason, canWrite };
};

/** Returns auth action dispatchers backed by Redux Saga side effects. */
export const useAuthActions = () => {
  const dispatch = useAppDispatch();

  /** Dispatches a login request and resolves after the saga finishes the API call. */
  const login = useCallback((username: string, password: string) => new Promise<void>((resolve, reject) => {
    dispatch(authActions.loginRequest({ username, password, resolve, reject }));
  }), [dispatch]);

  /** Dispatches a logout request with the supplied reason for local state and server notification. */
  const logout = useCallback((reason?: LogoutReason) => {
    dispatch(authActions.logoutRequest({ reason }));
  }, [dispatch]);

  return { login, logout };
};
